/** @jsxImportSource @emotion/react */
import { QtyInput } from '../../UI';
import { useCartBreakdown } from '../../../helpers';
import { useCart } from '@shared/cart-react';
import Price from '../Price';

const freeProducts = [
  'Yard Sign and 3 Window Stickers',
  'Accessories and Batteries',
  'Cove Connect App',
];

const CartBreakdown = () => {
  const {
    productList,
    panelHubPrice,
    totals: breakdownTotals,
    monthlyMonitoring,
  } = useCartBreakdown();
  const cart = useCart();
  const freeMonths = cart?.freeMonths ?? 0;
  return (
    <div className="flex w-full flex-col">
      <ul className="m-0 p-0">
        <li className="gap-cove-10 py-cove-10 border-b-cove-dove flex items-center justify-between border-b px-0">
          <div className="gap-cove-15 flex items-center">
            <p className="m-0 text-sm font-light">Hub and Alarm Panel</p>
          </div>
          <span className="text-right text-xs font-medium">
            ${panelHubPrice.toFixed(2)}
          </span>
        </li>
        {productList.map(product => {
          const isPanel = product.sku === 'CPA-PANEL-345-1';
          return (
            <li
              key={product.sku}
              className="gap-cove-10 py-cove-10 border-b-cove-dove last:border-b-cove-navy-blue flex items-center justify-between border-b px-0"
            >
              <div className="gap-cove-15 flex items-center">
                <QtyInput
                  value={product.qty}
                  onChange={newVal => {
                    const value = isPanel ? newVal + 1 : newVal;
                    cart.updateCartItem({ sku: product.sku, qty: value });
                  }}
                  min={0}
                  max={product.maximumSensorCountOnSite}
                />
                <p className="m-0 text-sm font-light">{product.name}</p>
              </div>
              <span className="text-right text-xs font-medium">
                ${(product.salePrice ?? 0).toFixed(2)}
              </span>
            </li>
          );
        })}
        {freeProducts.map(freeProduct => {
          return (
            <li
              key={freeProduct}
              className="gap-cove-10 py-cove-10 border-b-cove-dove last:border-b-cove-navy-blue flex items-center justify-between border-b px-0"
            >
              <div className="gap-cove-15 flex items-center">
                <p className="m-0 text-sm font-light">{freeProduct}</p>
              </div>
              <span className="text-cove-green text-right text-xs font-medium">
                Free
              </span>
            </li>
          );
        })}
      </ul>
      <div className="pt-cove-15 pb-cove-10 gap-cove-15 flex flex-col px-0">
        <div className="gap-cove-10 flex justify-between">
          <b>Equipment</b>
          <div>
            <Price
              price={breakdownTotals.equipment.price}
              salePrice={breakdownTotals.equipment.salePrice}
            />
          </div>
        </div>
        <div className="gap-cove-10 flex justify-between">
          <b>Monitoring</b>
          <div>
            <Price
              price={monthlyMonitoring}
              free={freeMonths > 1 && `${freeMonths} mos free`}
            />
          </div>
        </div>
        <div className="gap-cove-10 flex justify-between">
          <b>
            Shipping{' '}
            <span className="text-xs font-normal">2-5 Business days</span>
          </b>
          <div>
            <Price free />
          </div>
        </div>
        <div className="gap-cove-10 flex justify-between">
          <b>Total</b>
          <div>
            <Price salePrice={breakdownTotals.total.salePrice} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartBreakdown;
